import Axios from "axios";
import { authHeaders } from "./auth";

/**
 * ตัวเรียก API ลิงก์สั้น
 *
 * การยืนยันตัวตนใช้โทเคนที่ได้จากการล็อกอิน AD (ดู services/auth.js)
 * ไม่มีคีย์ลับใด ๆ ฝังอยู่ในไฟล์ build ของหน้าเว็บ
 */

const API_BASE = (process.env.REACT_APP_DOMAIN_SHORTLINK_API || "").replace(/\/+$/, "");

export const FALLBACK_URL = process.env.REACT_APP_SHORTLINK_FALLBACK_URL || "https://www.bigc.co.th";

export const SHORT_LINK_BASE =
  (process.env.REACT_APP_SHORTLINK_BASE || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/+$/, "");

export const isConfigured = () => Boolean(API_BASE);

const adminHeaders = () => ({ "Content-Type": "application/json", ...authHeaders() });

// ดึงข้อความ error ที่ API ส่งกลับมาให้อ่านรู้เรื่อง แทนที่จะโชว์ "Request failed with status code 400"
function toMessage(error, fallbackMessage) {
  const detail = error && error.response && error.response.data && error.response.data.error;
  if (detail && detail.message) return detail.message;
  if (error && error.message === "Network Error") return "ต่อ API ไม่ได้ ตรวจว่า REACT_APP_DOMAIN_SHORTLINK_API ถูกต้องและ Cloud Run เปิดอยู่";
  return fallbackMessage;
}

/**
 * หาปลายทางของโค้ด
 *
 * ห้ามโยน error ออกไป — ถ้า API ล่ม ผู้ที่สแกน QR ต้องได้ไปที่ fallback
 * ไม่ใช่ค้างอยู่หน้าขาว (กฎข้อ 2)
 */
export async function resolveCode(code, search) {
  if (!API_BASE) return { outcome: "not_configured", target: FALLBACK_URL };
  try {
    const result = await Axios.get(`${API_BASE}/api/resolve/${encodeURIComponent(code)}${search || ""}`, {
      timeout: 8000,
    });
    return result.data;
  } catch (error) {
    console.error("bigc-dmkt-link: resolveCode", error);
    return { outcome: "error", target: FALLBACK_URL };
  }
}

export async function listShortLinks(params) {
  const result = await Axios.get(`${API_BASE}/api/short-links`, { headers: adminHeaders(), params });
  return result.data;
}

export async function createShortLink(payload) {
  try {
    const result = await Axios.post(`${API_BASE}/api/short-links`, payload, { headers: adminHeaders() });
    return result.data;
  } catch (error) {
    throw new Error(toMessage(error, "สร้างลิงก์ไม่สำเร็จ"));
  }
}

export async function updateShortLink(code, payload) {
  try {
    const result = await Axios.patch(`${API_BASE}/api/short-links/${encodeURIComponent(code)}`, payload, {
      headers: adminHeaders(),
    });
    return result.data;
  } catch (error) {
    throw new Error(toMessage(error, "แก้ไขลิงก์ไม่สำเร็จ"));
  }
}

export async function getRevisions(code) {
  const result = await Axios.get(`${API_BASE}/api/short-links/${encodeURIComponent(code)}/revisions`, {
    headers: adminHeaders(),
  });
  return result.data;
}

/* ---------- คลังรูปโลโก้สำหรับวางกลาง QR ---------- */

export const logoImageUrl = (logo) => `${API_BASE}${logo.url}`;

export async function listLogos() {
  const result = await Axios.get(`${API_BASE}/api/qr-logos`, { headers: authHeaders() });
  return result.data;
}

export async function uploadLogo(name, dataUri) {
  try {
    const result = await Axios.post(
      `${API_BASE}/api/qr-logos`,
      { name, dataUri },
      { headers: adminHeaders() }
    );
    return result.data;
  } catch (error) {
    throw new Error(toMessage(error, "อัปโหลดรูปไม่สำเร็จ"));
  }
}

export async function setDefaultLogo(id) {
  try {
    const result = await Axios.patch(
      `${API_BASE}/api/qr-logos/${id}`,
      { isDefault: true },
      { headers: adminHeaders() }
    );
    return result.data;
  } catch (error) {
    throw new Error(toMessage(error, "ตั้งรูปเริ่มต้นไม่สำเร็จ"));
  }
}

export async function deleteLogo(id) {
  try {
    const result = await Axios.delete(`${API_BASE}/api/qr-logos/${id}`, { headers: authHeaders() });
    return result.data;
  } catch (error) {
    throw new Error(toMessage(error, "ลบรูปไม่สำเร็จ"));
  }
}

export const buildShortUrl = (code) => `${SHORT_LINK_BASE}/s/${code}`;
